const normalizeRole = (role?: string | null) => role?.trim().toLowerCase();

export const isDataAdmin = (role?: string | null) => {
    const normalizedRole = normalizeRole(role)
    return (
        normalizedRole === 'data admin' ||
        normalizedRole === 'data administrator'
    );
}

export const isSuperAdmin = (role?: string | null) => {
    const normalizedRole = normalizeRole(role);
    return normalizedRole === 'super admin';
};

export const isAdmin = (role?: string | null) => {
    const normalizedRole = normalizeRole(role);
    return (
        normalizedRole === 'administrator' ||
        normalizedRole === 'admin'
    );
};

export const canViewClientModule = (role?: string | null) =>
    isDataAdmin(role) || isSuperAdmin(role);